import { Normalize } from 'utils/types';
import { makeDataContext } from 'utils/prismic';

const [useHome, withHomeProvider] = makeDataContext<Normalize<Queries.HomeQuery>>();

export { useHome, withHomeProvider };
